import { sendRequest } from "../axios";
export default {
  state: {},
  mutations: {},
  actions: {
    GetSuppordData({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("GetSuppordData", "get").then(response => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    }
  },
  getters: {}
};
